
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Companies = lazy(() => import('../pages/companies/page'));
const Services = lazy(() => import('../pages/services/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/o-grupo',
    element: <About />,
  },
  {
    path: '/empresas-do-grupo',
    element: <Companies />,
  },
  {
    path: '/servicos',
    element: <Services />,
  },
  {
    path: '/contato',
    element: <Contact />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
